import { useMemo, useState } from 'react';
import InboxLeadsContext from './InboxLeadsContext';

// @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
const InboxLeadsContextProvider = ({ children }) => {
  const [selectedLeadUid, setSelectedLeadUid] = useState<string>();
  const [leadsMap, setLeadsMap] = useState({});
  const [threadRelatedLeadsMap, setThreadRelatedLeadsMap] = useState({});
  const [threadRelatedPropertiesMap, setThreadRelatedPropertiesMap] = useState(
    {},
  );
  const contextValue = useMemo(
    () => ({
      leadsMap,
      selectedLeadUid,
      threadRelatedLeadsMap,
      threadRelatedPropertiesMap,
      setSelectedLeadUid,
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      deleteLeadFromMap: (leadUid) => {
        setLeadsMap((currentMap) => {
          // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
          delete currentMap[leadUid];
          return { ...currentMap };
        });
      },
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      updateLeadsMap: (lead) => {
        setLeadsMap((currentMap) => ({
          ...currentMap,
          [lead.uid]: lead,
        }));
      },
      // @ts-expect-error TS7031 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      updateThreadRelatedLeadsMap: ({ threadUid, leads }) => {
        setThreadRelatedLeadsMap((currentMap) => ({
          ...currentMap,
          [threadUid]: leads,
        }));
      },
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      isThreadRelatedPropertyExists: (threadUid) => {
        // @ts-expect-error TS7053 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
        return !!threadUid && !!threadRelatedPropertiesMap[threadUid];
      },
      // @ts-expect-error TS7006 [STRICT-MIGRATION] Temporarily suppressing strict type checking - should be fixed when this code is next modified
      addThreadRelatedProperty: (threadUid, property) => {
        setThreadRelatedPropertiesMap((previousMap) => ({
          ...previousMap,
          [threadUid]: property,
        }));
      },
    }),
    [leadsMap, selectedLeadUid, threadRelatedLeadsMap],
  );

  return (
    <InboxLeadsContext.Provider value={contextValue}>
      {children}
    </InboxLeadsContext.Provider>
  );
};

export default InboxLeadsContextProvider;
